import { apiFetch } from '@/src/api/apiService';
import { API_BASE } from '@/src/api/config';
import { saveReferralLinkValidityDays, type ReferralEligibility } from '@/src/utils/pendingReferral';

/**
 * Read-only eligibility of a referral code kept on the device (ALL-22, D-057).
 *
 * Uses the public `/validate-code/` endpoint WITHOUT a registration token: the
 * server only answers whether the code belongs to an active partner/campaign
 * and writes nothing (no candidate, no attribution). Attribution still happens
 * only through the signup field's server-issued session. With `capturedAt` the
 * server also rejects a link older than the Admin link validity (D-057).
 */
export async function checkReferralEligibility(code: string, capturedAt?: string): Promise<ReferralEligibility> {
  try {
    const response = await apiFetch<{ valid?: boolean; link_validity_days?: number }>(
      `${API_BASE}/api/referrals/validate-code/`,
      {
        method: 'POST', includeCompanyContext: false, timeoutMs: 8000,
        body: JSON.stringify(capturedAt ? { code, link_captured_at: capturedAt } : { code }),
      },
      false,
      false,
    );
    if (response.ok && response.data?.valid === true) {
      await saveReferralLinkValidityDays(response.data.link_validity_days);
      return 'valid';
    }
    if (response.status === 400) return 'invalid';
    return 'unavailable';
  } catch {
    return 'unavailable';
  }
}
